"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _RadioButtonUnchecked = _interopRequireDefault(require("@material-ui/core/internal/svg-icons/RadioButtonUnchecked"));

var _RadioButtonChecked = _interopRequireDefault(require("@material-ui/core/internal/svg-icons/RadioButtonChecked"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sharedCss = _interopRequireDefault(require("../../shared/oldDocumentSignerUI/sharedCss"));

var _fieldStatusClass = _interopRequireDefault(require("./fieldStatusClass"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = _objectSpread(_objectSpread({}, _sharedCss.default.fields), {}, {
  radioGroup: {},
  input: {
    borderRadius: '50%'
  }
});

var RadioGroup = function RadioGroup(props) {
  var id = props.id,
      name = props.name,
      handleChange = props.handleChange,
      classes = props.classes,
      radioGroupItems = props.radioGroupItems,
      value = props.value,
      setFieldRef = props.setFieldRef,
      page = props.page,
      isDisabled = props._derived.isDisabled;
  var inputClass = (0, _classnames.default)(classes.input, (0, _fieldStatusClass.default)(props));
  var radioOptions = radioGroupItems.filter(function (option) {
    return option.page === page;
  }).map(function (option) {
    var x = option.x,
        preAdjustmentY = option.y,
        height = option.height,
        width = option.width,
        buttonValue = option.name;
    var y = preAdjustmentY + height * 0.7;
    var fieldDynamicStyle = {
      position: 'absolute',
      top: y,
      left: x,
      height: height,
      width: width
    };
    return /*#__PURE__*/_react.default.createElement(_core.Radio, {
      icon: /*#__PURE__*/_react.default.createElement(_RadioButtonUnchecked.default, {
        style: {
          height: height * 1.15,
          width: width * 1.15
        },
        className: inputClass
      }),
      checkedIcon: /*#__PURE__*/_react.default.createElement(_RadioButtonChecked.default, {
        style: {
          height: height * 1.15,
          width: width * 1.15
        },
        className: inputClass
      }),
      style: fieldDynamicStyle,
      value: buttonValue,
      key: "".concat(name, "-").concat(buttonValue),
      "data-test-id": "RadioGroup-radio-".concat(name, "/").concat(buttonValue),
      disabled: isDisabled
    });
  });
  var adjustedY = radioGroupItems[0].y + radioGroupItems[0].height * 0.7;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "RadioGroup-root-".concat(id)
  }, /*#__PURE__*/_react.default.createElement(_core.Input, {
    inputRef: function inputRef(e) {
      return setFieldRef(e, adjustedY);
    },
    type: "hidden"
  }), /*#__PURE__*/_react.default.createElement(_core.RadioGroup, {
    name: name,
    className: classes.radioGroup,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    value: value
  }, radioOptions));
};

var _default = (0, _styles.withStyles)(styles)(RadioGroup);

exports.default = _default;